import styled from 'styled-components';
import { Theme, Box, BoxProps } from '@material-ui/core';

const theme = (props: any) => {
  return props.theme as Theme;
}

export const StyledScrollBox = styled(Box)(props => ({
  overflow: 'hidden',
  display: 'flex',
  position: 'relative',
  maxHeight: props['maxHeight'],
})) as React.FC<{ maxHeight?: string; } & BoxProps>;

export const StyledScroll = styled(Box)(props => ({
  padding: theme(props).spacing(0.5, 1),
  flex: 1,
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
})) as typeof Box;